const sendMessageToPlayer = (action, dataObj) => {
  const iframe = window.frames.OrionPlayer;
  if (iframe) {
    const obj = dataObj || {};
    iframe.postMessage({
      id: '360parent',
      action,
      data: obj,
    }, '*');
  }
};

export { sendMessageToPlayer as default };
